package com.milta.feature.subscription.data.remote

import com.milta.core.network.Endpoints
import com.milta.core.network.baseUrl
import com.milta.core.network.ApiException
import com.milta.feature.auth.data.remote.dto.ApiError
import com.milta.feature.subscription.data.remote.dto.SubmitReceiptRequest
import com.milta.feature.subscription.data.remote.dto.SubscriptionDto
import com.milta.feature.subscription.data.remote.dto.SubscriptionPlanInfoDto
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType
import io.ktor.http.isSuccess

class SubscriptionApi(private val client: HttpClient) {

    suspend fun getMySubscription(): SubscriptionDto {
        val response = client.get("$baseUrl/${Endpoints.subscriptionMe}")
        if (!response.status.isSuccess()) {
            val apiError = runCatching { response.body<ApiError>() }.getOrNull()
            val message = apiError?.code ?: "error_${response.status.value}"
            throw ApiException(response.status.value, message)
        }
        return response.body()
    }

    suspend fun getPlans(): List<SubscriptionPlanInfoDto> {
        val response = client.get("$baseUrl/${Endpoints.subscriptionPlans}")
        if (!response.status.isSuccess()) {
            val apiError = runCatching { response.body<ApiError>() }.getOrNull()
            val message = apiError?.code ?: "error_${response.status.value}"
            throw ApiException(response.status.value, message)
        }
        return response.body()
    }

    suspend fun submitReceipt(request: SubmitReceiptRequest): SubscriptionDto {
        val response = client.post("$baseUrl/${Endpoints.subscriptionReceipt}") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }
        if (!response.status.isSuccess()) {
            val apiError = runCatching { response.body<ApiError>() }.getOrNull()
            val message = apiError?.code ?: "error_${response.status.value}"
            throw ApiException(response.status.value, message)
        }
        return response.body()
    }
}
